import "@hipo/react-ui-toolkit/dist/main.css";

import React from "react";
import ReactDOM from "react-dom/client";

import "./core/ui/style/_global.scss";

import App from "./core/app/App";
import {setupPeraConnectObserver} from "./core/integrations/pera-wallet/PeraConnect.utils";
import {WalletContextProvider} from "./wallet/util/context/WalletContext";
import {setupDeflyConnectObserver} from "./core/integrations/defly/DeflyWallet.utils";
import {AssetPriceContextProvider} from "./asset/price/context/AssetPriceContext";
import {AssetIconContextProvider} from "./asset/icon/context/AssetIconContext";
import {VerifiedAssetsContextProvider} from "./asset/verified/context/VerifiedAssetsContext";
import {setupWalletConnectObserver} from "./core/integrations/wallet-connect/WalletConnect.utils";

setupPeraConnectObserver();
setupDeflyConnectObserver();
setupWalletConnectObserver();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <WalletContextProvider>
      <AssetPriceContextProvider>
        <AssetIconContextProvider>
          <VerifiedAssetsContextProvider>
            <App />
          </VerifiedAssetsContextProvider>
        </AssetIconContextProvider>
      </AssetPriceContextProvider>
    </WalletContextProvider>
  </React.StrictMode>
);
